// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DocumentOutlinedSvg from "@fishx/icons-svg/es/asn/DocumentOutlined";
import FishxIcon from '../components/FishxIcon';

var DocumentOutlined = function DocumentOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DocumentOutlinedSvg
  }));
};

DocumentOutlined.displayName = 'DocumentOutlined';
export default React.forwardRef(DocumentOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DocumentOutlined.js
// module id = 2431
// module chunks = 0